import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { allowWindowResize, disableWindowResize } from 'shared-utils/src/lockScreen/utils';

import sharedHandleSocial from './utils/sharedHandleSocial'

const emailCheck = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const propTypes = {
  device: PropTypes.string,
  currentUrl: PropTypes.string,
  mobileOs: PropTypes.string,
  portalDomain: PropTypes.string,
  accountDomain: PropTypes.string,
  authBasePrefix: PropTypes.string,
  logIn: PropTypes.func,
  onLogInComplete: PropTypes.func,
  onLoginFailed: PropTypes.func,
  postLoginAction: PropTypes.func,
  cookiesConfig: PropTypes.object,
  email: PropTypes.string,
  setFatherEmail: PropTypes.func,
  from: PropTypes.string,
};
const defaultProps = {
  device: null,
  currentUrl: '/',
  mobileOs: null,
  portalDomain: 'https://www.casa.it',
  accountDomain: 'https://www.casa.it',
  authBasePrefix: '/my',
  logIn: null,
  onLogInComplete: null,
  onLoginFailed: () => { },
  postLoginAction: null,
  cookiesConfig: {},
  email: null,
  setFatherEmail: () => { },
  from: null,
};


const LoginLogic = ({
  accountDomain = 'https://www.casa.it',
  authBasePrefix = '/my',
  device,
  mobileOs,
  currentUrl,
  logIn,
  onLogInComplete,
  onLoginFailed,
  postLoginAction,
  cookiesConfig = {
    cookiePublisherKey: "publisherCookie",
    cookieRememberMeKey: "remember_me",
    cookieSessionName: "session",
  },
  modalData,
  loginCallBack,
  loginCallBackPayload,
  children,
  email,
  setFatherEmail,
  from,
}) => {
  // const accountDomain = 'http://localhost:3002'
  const isDesktop = device === 'desktop';
  const [userName, setUserName] = useState(email);
  const [userPwd, setUserPwd] = useState(null);
  const [validationErrors, setValidationErrors] = useState([]);
  const [loggingIn, setLogginIn] = useState(false);
  const [loginError, setLoginError] = useState(null);
  const [loginSocialError, setLoginSocialError] = useState(null);
  const [messageLoginError, setMessageLoginError] = useState('');
  const encodedCurrentUrl = encodeURIComponent(currentUrl);

  const handleLoginRes = (data) => {
    setLogginIn(false);
    if (data?.success) {
      loginCallBack({
        closeModal: modalData && modalData.close,
        ...loginCallBackPayload,
        jwt: data?.jwt,
      })
      // }
      // if (data?.success && postLoginAction) {
      //   postLoginAction();
      // } else if (data?.success) {
      //   document.documentElement.classList.remove('locked');
      //   onLogInComplete()
    } else {
      onLoginFailed && onLoginFailed({ email: userName });
      setLoginError(true);
      setMessageLoginError('Impossibile effettuare il login: email o password non riconosciuti')
    }
  };

  const doLogin = () => {
    if (mobileOs === 'ios') {
      disableWindowResize();
    }

    if (validationErrors.length > 0) {
      return;
    }
    if (
      (userName === '' || userName === null)
      && (userPwd === '' || userPwd === null)
    ) {
      const errors = validationErrors.slice(0);
      if (errors.indexOf('password') < 0) {
        errors.push('password');
      }
      if (errors.indexOf('email') < 0) {
        errors.push('email');
      }
      setValidationErrors(errors);
    } else if (userPwd === '' || userPwd === null) {
      const errors = validationErrors.slice(0);
      if (errors.indexOf('password') < 0) {
        errors.push('password');
      }
      setValidationErrors(errors);
    } else if (userName === '' || userName === null) {
      const errors = validationErrors.slice(0);
      if (errors.indexOf('email') < 0) {
        errors.push('email');
      }
      setValidationErrors(errors);
    } else {
      setLogginIn(true);
      logIn(
        handleLoginRes,
        {
          email: userName,
          password: userPwd,
          app: 'prt',
          path: currentUrl,
          postLoginAction,
          cookiesConfig,
          from,
        },
      );
    }
  };

  const storeLoginData = (fieldName, fieldValue) => {
    if (fieldName === 'email') {
      setFatherEmail && setFatherEmail(fieldValue);
      setUserName(fieldValue);
    } else {
      setUserPwd(fieldValue);
    }
  };

  const validateLoginData = (e) => {
    if (mobileOs === 'ios') {
      allowWindowResize();
      setTimeout(() => disableWindowResize(), 200);
    }

    const fieldName = e.target.name;
    const fieldValue = e.target.value;
    const errors = validationErrors.slice(0);
    if (fieldName === 'email') {
      if (
        fieldValue !== ''
        && !emailCheck.test(fieldValue)
      ) {
        if (errors.indexOf(fieldName) < 0) {
          errors.push(fieldName);
        }
        setValidationErrors(errors);
      }
    }
  };

  const removeError = (e) => {
    if (mobileOs === 'ios') {
      disableWindowResize();
    }

    const fieldName = e.target.name;
    if (loginError || loginSocialError) {
      setValidationErrors([]);
      setLoginError(false);
      setLoginSocialError(false);
      setMessageLoginError('');
    } else {
      const errors = validationErrors.slice(0);
      if (errors.indexOf(fieldName) > -1) {
        errors.splice(errors.indexOf(fieldName), 1);
        setValidationErrors(errors);
        setLoginError(false);
        setLoginSocialError(false);
        setMessageLoginError('');
      }
    }
  };

  const socialHandleLogin = ({ href = '', useWorkaround = false }) => {
    sharedHandleSocial({
      href,
      useWorkaround,
      cookiesConfig,
      onDone: ({ error = false, jwt } = {}) => {
        document.documentElement.classList.remove('locked');
        if (error) {
          setLoginSocialError(true);
          setMessageLoginError('Impossibile effettuare il login tramite social al momento.');
        } else {
          logIn(
            () => {
              loginCallBack({
                closeModal: modalData && modalData.close,
                ...loginCallBackPayload,
                jwt,
              })
            },
            // postLoginAction
            // ? postLoginAction
            // : onLogInComplete,
            {
              isSocialLogin: true,
              cookiesConfig,
              from
            },
          );
        }
      }
    })
  }

  return children({
    accountDomain,
    authBasePrefix,
    cookiesConfig,
    isDesktop,
    userName,
    userPwd,
    validationErrors,
    loggingIn,
    loginError,
    loginSocialError,
    messageLoginError,
    encodedCurrentUrl,
    handleLoginRes,
    doLogin,
    storeLoginData,
    validateLoginData,
    removeError,
    socialHandleLogin,
    setUserName,
    setUserPwd,
    setValidationErrors,
    setLoginError,
    setLoginSocialError,
    setMessageLoginError,
    doLogin,

  });
};
LoginLogic.propTypes = propTypes;
LoginLogic.defaultProps = defaultProps;
export default LoginLogic;